var MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Requests = MDB.GDPR.Requests || {};

$.extend(MDB.GDPR.Requests, {
    bootOverview: function () {
        $('.gdpr-request-row').on('click', function() {
            window.location.href = $(this).data('url');
        });

        var tableSelector = $('.dataTable.request-table');
        var tableApi = tableSelector.dataTable().api();
        var headers = tableSelector.find('th');

        var sortOrder = [];
        _.forEach(headers, function (el, idx) {
            var order = $(el).data('order');
            if (order) {
                sortOrder.push([idx, order]);
            }
        });
        
        tableApi.order(sortOrder).draw();
    }
});